export default {
  messages: {
    en: {
      descriptions: {
        defaulted: {
          group: `{name}'s loan has been defaulted.`,
          individual: {
            f: `{name}'s loan has been defaulted.`,
            m: `{name}'s loan has been defaulted.`,
          },
        },
        finished: {
          group: '{name} have fully repaid their loan of <strong>{amount}</strong>.',
          individual: {
            f: '{name} has fully repaid her loan of <strong>{amount}</strong>',
            m: '{name} has fully repaid his loan of <strong>{amount}</strong>',
          },
        },
        devalued: {
          group: '{name} have fully repaid their loan of <strong>{amount}</strong>.',
          individual: {
            f: '{name} has fully repaid her loan of <strong>{amount}</strong>',
            m: '{name} has fully repaid his loan of <strong>{amount}</strong>',
          },
        },
        funded: {
          group: '{name} needed <strong>{amount}</strong> for their business.',
          individual: {
            f: '{name} needed <strong>{amount}</strong> for her business.',
            m: '{name} needed <strong>{amount}</strong> for his business.',
          },
        },
        open: {
          group: '{name} need just <strong>{amount}</strong> to complete their loan.',
          individual: {
            f: '{name} needs just <strong>{amount}</strong> to complete her loan.',
            m: '{name} needs just <strong>{amount}</strong> to complete his loan.',
          },
        },
      },
    },
  },
}
